<template>
  <div class="bottom-safe" :style="{ 'padding-top': offsetHeight + 'px' }">
    <form action="/">
      <van-search
        ref="searchInput"
        placeholder="搜搜感兴趣的私房课"
        input-align="left"
        v-model="searchKeyword"
      ></van-search>
    </form>
    <van-panel
      v-if="panelTitle&&itemsCount > 0"
      :title="panelTitle" :desc="itemsCountLabel" status="">
    </van-panel>
    <van-empty
      v-else
      description="没找到相关私房课"
    />
    <episode-list
      v-if="searchKeyword"
      :slug="slug"
      :search-keyword="searchKeyword"
      :show-no-more-hint="false"
      @got-episodes-count="gotEpisodesCount"
    />
  </div>
</template>

<script>
  // import store from '../../store/index'
  import Vue from 'vue'
  import { NavBar } from 'vant'
  import { Panel } from 'vant'
  import { Empty } from 'vant'
  import EpisodeList from '../episode-list.vue'
  Vue.use(NavBar)
  Vue.use(Panel)
  Vue.use(Empty)
  // import axios from 'axios'

  export default {
    name: "SearchPage",
    components: {
      EpisodeList
    },
    data () {
      return {
        prevFullPath: '',
        slug: '',
        offsetHeight: 0,
        itemsCountLabel: '',
        itemsCount: 0,
        panelTitle: '',
        searchKeyword: ''
      }
    },
    computed: {
      
    },
    methods: {
      // onClickLeft() {
      //   store.commit("clearPrevFullPath")
      //   this.$router.replace({
      //     path: this.prevFullPath
      //   })
      // }
      
      onFocus() {
        // this.$refs.searchInput.$children[0].focus()
        this.$refs.searchInput.querySelector('input').focus()
      },

      searchEpisodes() {
        // let params = {
        //   slug: this.slug,
        // }
        // this.$api.episode.list(params).then(res => {
        //   window.console.log("搜索到的Episodes:", res)
        //   this.itemsCountLabel = `共 ${res.data.results.length} 期：`
        // })
      },

      gotEpisodesCount(count) {
        window.console.log("收到节目数量：")
        this.itemsCountLabel = `共 ${count} 期：`
        this.itemsCount = count
      }
    },
    watch: {
      searchKeyword (value) {
        if (value) {
          this.panelTitle = `与 “${value}” 相关的私房课`
        } else {
          this.panelTitle = ''
        }
      }
    },
    mounted () {
      this.onFocus()
      this.slug = this.$route.params.slug
      this.searchEpisodes()
      // let that = this
      // if (store.state.prevFullPath) {
      //   that.prevFullPath = store.state.prevFullPath
      //   if (store.state.prevFullPath) {
      //     that.$nextTick(function() {
      //       that.offsetHeight = that.$refs.navBar.$el.offsetHeight
      //     })
      //   }
      // }
    }
  }
</script>

<style lang="css" scoped>
  /* .block{
    margin-top: 10px;
  } */
</style>
